import Cookies from 'js-cookie'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  isAuthenticated: boolean
}

type Actions = {
  setAuthenticated: (_value: boolean) => void
  clearAuth: () => void
}

export const STORAGE_NAME = 'modulnova-auth'
const COOKIE_EXPIRES_DAYS = 7
const COOKIE_OPTIONS = {
  expires: COOKIE_EXPIRES_DAYS,
  path: '/',
  sameSite: 'lax' as const,
  secure: process.env.NODE_ENV === 'production'
}

const getInitialAuth = () =>
  typeof window !== 'undefined' ? Cookies.get(STORAGE_NAME) === '1' : false

const initialState: State = {
  isAuthenticated: getInitialAuth()
}

const useAuthStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,

      setAuthenticated: (value) => {
        set((state) => {
          state.isAuthenticated = value
        })
        if (value) {
          Cookies.set(STORAGE_NAME, '1', COOKIE_OPTIONS)
        } else {
          Cookies.remove(STORAGE_NAME, { path: '/' })
        }
      },

      clearAuth: () => {
        set((state) => {
          state.isAuthenticated = false
        })
        Cookies.remove(STORAGE_NAME, { path: '/' })
      }
    }))
  )
)

export { useAuthStore }
